import * as React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/global/seo"
import BlogArticle from "../components/blog_detail/blog_article"
import BlogSidebar from "../components/blog/blog_sidebar"

// import BlogUi from "../components/blog_detail/blog_ui"

import CategoryData from "../../content/data/category.yml"

const BlogPostTemplate = ({ data, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const siteUrl = data.site.siteMetadata.siteUrl
  const postCategory = post.frontmatter.category
  const relatedPosts = data.allMarkdownRemark.nodes

  return (
    <Layout location={location} title={siteTitle}>
      <div className="container mx-auto py-4">
        <nav aria-label="breadcrumb">
          <ol className="flex md:text-sm text-gray-600" vocab="https://schema.org/" typeof="BreadcrumbList">
            <li property="itemListElement" typeof="ListItem">
              <Link to="/" property="item" typeof="WebPage">
                <span property="name">トップページ</span>
              </Link>
              <meta property="position" content="1"/>
            </li>
            <li className="mx-2">/</li>
            <li property="itemListElement" typeof="ListItem">
              <Link to={`/${postCategory}`} property="item" typeof="WebPage">
                <span property="name">{CategoryData[postCategory]['title']}</span>
              </Link>
              <meta property="position" content="2"/>
            </li>
            <li className="mx-2">/</li>
            <li className="article_breadcrumb_title" property="itemListElement" typeof="ListItem">
              <span property="name">{ post.frontmatter.title }</span>
              <meta property="position" content="3"/>
            </li>
          </ol>
        </nav>
      </div>
      <div className="container mx-auto mt-4">
        <div className="grid md:grid-cols-12 gap-5">
          <div className="md:col-span-8 lg:pr-4">
            <BlogArticle post={post} siteUrl={siteUrl} relatedPosts={relatedPosts} />
          </div>
          <aside className="mt-8 md:mt-0 md:col-span-4 lg:pl-10">
            <BlogSidebar category={postCategory} />
          </aside>
        </div>
      </div>
      {/*
      <div className="container mx-auto mt-20 py-14 border-t border-slate-200">
        <h2 className="capitalize text-3xl font-bold">UI <span className="ml-1 py-1 px-2 rounded leading-none text-xs font-bold bg-indigo-600 text-white">BETA</span></h2>
        <BlogUi />
        <div className="flex justify-center mt-10">
          <Link className="py-2 px-6 border border-slate-200 rounded text-slate-500 font-bold" to="/ui">一覧を見る</Link>
        </div>
      </div>
      */}
    </Layout>
  )
}

export const Head = ({ data }) => {
  const post = data.markdownRemark
  const siteUrl = data.site.siteMetadata.siteUrl
  const pageUrl = `${siteUrl}/${post.frontmatter.url}`

  return (
    <Seo
      title={post.frontmatter.title}
      description={post.frontmatter.description || post.excerpt}
      image={post.frontmatter.image}
      pageUrl={pageUrl}
      siteUrl={data.site.siteMetadata.siteUrl}
      post={post}
      schemaType={'blog'}
    />
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($id: String!, $category: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(truncate: true, pruneLength: 100)
      html
      tableOfContents(maxDepth: 3)
      frontmatter {
        title
        date(formatString: "YYYY / MM / DD")
        lastmod(formatString: "YYYY / MM / DD")
        description
        url
        image
        category
      }
    }
    allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "/content/blog/"}, id: {ne: $id}, frontmatter: {category: {eq: $category}, draft: {eq: false}}}
      sort: {frontmatter: {date: DESC}}
      limit: 6
    ) {
      nodes {
        excerpt(truncate: true, pruneLength: 60)
        frontmatter {
          date(formatString: "YYYY / MM / DD")
          lastmod(formatString: "YYYY / MM / DD")
          url
          image
          title
          description
        }
      }
    }
  }
`
